import gql from 'graphql-tag';

const ACCEPT_SIMULATION_MUTATION = gql`
  mutation(
      $simulationId: Int!,
      $calculationType: Int!,
      $yearlypremium: Decimal,
      $backservice: Decimal,
      $comment: String
      ) {  
      acceptSimulation(
      simulationId: $simulationId,
      calculationType: $calculationType,
      yearlypremium: $yearlypremium,
      backservice: $backservice,
      comment: $comment
    ){
      simulationId
    }
  }
`;

export default ACCEPT_SIMULATION_MUTATION;
